import React from 'react';
import StyledPaginationArrow, {StyledPaginationArrowLabel} from './styles';
import Props from './typings';
import Icon from '../../../../atoms/Icon/Icon';
import colors from '../../../../theme/constants/colors';

const PaginationArrow = ({left, right, href, disabled = false, onClick}: Props) => {
  return (
    <StyledPaginationArrow
      onClick={(e) => {
        e.preventDefault();
        onClick();
      }}
      href={disabled ? undefined : href}
      aria-label={left && !right ? 'Previous page' : 'Next page'}
      aria-disabled={disabled}
      $disabled={disabled}
      $leftArrow={left}
      as={disabled ? 'button' : undefined}
    >
      {left && !right && (
        <Icon
          type="chevron-left"
          fontSize={16}
          color={disabled ? colors.grey100 : colors.darkBlue100}
        />
      )}

      <StyledPaginationArrowLabel>
        {left && !right ? 'Previous page' : 'Next page'}
      </StyledPaginationArrowLabel>

      {!left && right && (
        <Icon
          type="chevron-right"
          fontSize={16}
          color={disabled ? colors.grey100 : colors.darkBlue100}
        />
      )}
    </StyledPaginationArrow>
  );
};

export default PaginationArrow;
